import { clsx } from 'clsx';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  className?: string;
  /** Accessible label for screen readers (if needed) */
  'aria-label'?: string;
}

export default function Badge({ 
  children, 
  variant = 'default', 
  className,
  'aria-label': ariaLabel 
}: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        {
          'bg-slate-800 text-slate-300': variant === 'default',
          'bg-green-900/50 text-green-400 border border-green-800': variant === 'success',
          'bg-yellow-900/50 text-yellow-400 border border-yellow-800': variant === 'warning',
          'bg-red-900/50 text-red-400 border border-red-800': variant === 'error',
          'bg-blue-900/50 text-blue-400 border border-blue-800': variant === 'info',
        },
        className
      )}
      aria-label={ariaLabel}
    >
      {children}
    </span>
  );
}
